export default __webpack_public_path__ + "static/media/chlormaker-manual.ce929f8e.pdf";